<template>
  <div>
    <v-container fluid>
      <v-card>

        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Alterar logo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="primary lighten-4 mr-2"
            @click="$router.push('/')"
            :disabled="loading || salvando"
            >Cancelar</v-btn
          >
          <v-btn
            class="primary lighten-4"
            :loading="loading || salvando"
            :disabled="loading || salvando"
            @click="salvarLogo"
            >Salvar</v-btn
          >
        </v-app-bar>

        <v-card-text>

          <v-container fluid class="py-0">
            <v-row>
              <v-col class="pb-0">
                <span class="ml-4 grey--text"
                  >Sua logo será usada nas impressões de pedidos feitos fora da rodada.</span
                >
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col class="d-flex child-flex" cols="12" xl="2" lg="3" md="4" sm="6">
                <v-card>
                  <v-img
                    :src="logoImg"
                    aspect-ratio="1"
                    class="grey lighten-2 white--text align-end"
                  ></v-img>
                  <v-card-actions style="display: flex; flex-direction: column;">
                    <span
                        class="primary--text"
                        style="width: 100%; text-align: center"
                        >Clique aqui para alterar a logo</span
                      >
                      <v-btn
                        rounded
                        class="ma-2"
                        color="primary"
                        @click.stop="alterarLogo"
                      >
                        <v-icon>add</v-icon>
                      </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

        </v-card-text>
      </v-card>
    </v-container>

    <CaptureImage ref="changeLogo" title="Alterar Logo" @imagemCapturada="capturarLogo"/>
  </div>
</template>

<script>
import CaptureImage from "@/components/CaptureImage";
import ServiceFornecedor from "../services/fornecedores.js";

export default {
  name: "AlterarLogo",
  components: {
    CaptureImage
  },
  data() {
    return {
      loading: false,
      salvando: false,
      user: {},
      logoImg: "",
    };
  },

  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.listarLogo(this.user.fornecedor_id);
  },

  methods: {
    alterarLogo() {
      this.$refs.changeLogo.chooseImage();
    },
    capturarLogo(new_logo) {
      this.logoImg = new_logo;
      this.$refs.changeLogo.fechar();
    },
    async listarLogo(fornecedor_id) {
      this.loading = true;
      try {
        let response = await ServiceFornecedor.listarLogo(fornecedor_id);
        this.logoImg = response.data.logo;
      } catch (error) {
        console.error(error);
        this.$eventbus.erro("Erro ao carregar a logo");
      } finally {
        this.loading = false;
      }
    },
    async salvarLogo() {
      this.salvando = true;

      try {
        await ServiceFornecedor.salvarLogo(this.user.fornecedor_id, {
          logo: this.logoImg
        });

        this.$eventbus.notificar("Logo salva com sucesso");

        this.$router.push('/');
      } catch (error) {
        console.error(error);
        this.$eventbus.erro("Erro ao salvar a logo");
      } finally {
        this.salvando = false;
      }
    }
  }
};
</script>

<style scoped></style>

